import { CommandLogin } from "./commands/cmdLogin";
import { CommandLoginExternal } from "./commands/cmdLoginExternal";
import { CmdTokenLogin } from "./commands/cmdTokenLogin.ts";
import { CmdLoginMfaGoogle } from "./commands/cmdLoginMfaGoogle.ts";



export class LoginService {

    async login(userName: string, password: string) {
        const cmd = new CommandLogin();
        const results = await cmd.run(userName, password);
        return results;
    }

    async loginPlatformExternal(token: string) {
        const cmd = new CommandLoginExternal();
        const results = await cmd.run(token);
        return results;
    }

    async tokenLogin(token: string) {
        const cmd = new CmdTokenLogin();
        const results = await cmd.run(token);
        return results;
    }

    async mfaLoginGoogle(loginChallenge: string, idToken: string) {
        const cmd = new CmdLoginMfaGoogle();
        return await cmd.run(loginChallenge, idToken);
    }
}
